// extracted by mini-css-extract-plugin
var _1 = "FlatFormInhabitantFields-moduleaccordionItem__FC_qY";
export { _1 as "accordionItem" }
